import React from 'react';
import { useSelector } from 'react-redux';

import ActionCard from 'components/Common/Cards/ActionCard';
import { getLoanGoal } from 'selectors/getLoanGoal';
import { RoutePath } from 'enums/Routes';
import { useNavigate } from 'hooks/useNavigate';

import styles from './ConnectAccountsSection.module.scss';

const ConnectAccountsSection: React.FC = () => {
  const { plaidConnected, isLoading } = useSelector(getLoanGoal);
  const navigate = useNavigate();

  if (plaidConnected || isLoading) return null;

  const handleConnectAccountsClick = () => {
    analytics.track('Dashboard Connect Accounts Clicked');
    navigate(RoutePath.PlaidCheckingAccounts);
  };

  return (
    <div className={styles.connectAccountsSection}>
      <ActionCard>
        <div>
          <ActionCard.Title>Connect accounts to track your progress</ActionCard.Title>
          <ActionCard.Description>
            Connect to your accounts and we&apos;ll track your progress toward your goal. If you start falling behind,
            we&apos;ll show you simple ways to catch up.
          </ActionCard.Description>
        </div>
        <ActionCard.Button className={styles.connectButton} onClick={handleConnectAccountsClick}>
          CONNECT ACCOUNTS
        </ActionCard.Button>
      </ActionCard>
    </div>
  );
};

export default ConnectAccountsSection;
